import { render, staticRenderFns } from "./bulkShippingList.vue?vue&type=template&id=737fdfb5&scoped=true&"
import script from "./bulkShippingList.vue?vue&type=script&lang=js&"
export * from "./bulkShippingList.vue?vue&type=script&lang=js&"
import style0 from "./bulkShippingList.vue?vue&type=style&index=0&id=737fdfb5&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737fdfb5",
  null
  
)

export default component.exports